'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _surveyDataNotifier = require('./survey-data-notifier');

var _surveyDataNotifier2 = _interopRequireDefault(_surveyDataNotifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sends traffic impression event
 *
 * @param {String} eid The traffic event id
 * @private
 */
var sendImpression = function sendImpression(eid) {
  if (window._trfq) {
    window._trfq.push(['cmdLogImpression', eid]);
  }
};

/**
 * Sends traffic specified event
 *
 * @param {String} eventType The specified event type
 * @param {String} eid The traffic event id
 * @param {Array} args The traffic event args
 * @private
 */
/* eslint max-params: ["error", 5] */
var sendEvent = function sendEvent(eventType, eid, args) {
  if (window._trfq) {
    window._trfq.push(['cmdLogPageEvent', eventType, eid, args]);
  }
};

/**
 * Strips host from url
 *
 * @returns {string} The extension string
 *
 * @param {string} url The url that is being parsed
 * @private
 */
var parse = function parse(url) {
  var firstIndex = url.indexOf('//');
  if (firstIndex !== -1) {
    var secondIndex = url.indexOf('/', firstIndex + 2);
    if (secondIndex !== -1) {
      return url.substring(secondIndex);
    }
  }
  return url;
};

/**
 * Sends utterance traffic event
 *
 * @param {string} eventName Ending of the name of the traffic event
 * @param {Object} utterance The user utterance
 * @param {Object} identifiers Object of sessionId, productId, botProjectId, lastIntentId
 * @private
 */
var sendUtteranceEvent = function sendUtteranceEvent(eventName, utterance, identifiers) {
  var sessionId = identifiers.sessionId,
      productId = identifiers.productId,
      botProjectId = identifiers.botProjectId,
      lastIntentId = identifiers.lastIntentId;


  sendEvent('custom', 'cx.help-bot.user.' + eventName, [['utterance', utterance], ['bsid', sessionId], ['product', productId]]);

  _surveyDataNotifier2.default.notifyUserUtterance(botProjectId, {
    utterance: utterance,
    bsid: sessionId,
    product: productId,
    lastIntentId: lastIntentId
  });
};

/**
 * Sends bot action traffic event
 *
 * @param {string} eventName Name of the traffic event
 * @param {Object} intent The traffic event id
 * @param {string} sessionId The id of the bot session the user is in
 * @param {string} val The relevant text value of the bot action item
 * @param {string} event The relevant text value of the bot action item
 * @private
 */
// eslint-disable-next-line max-params
var sendBotActionEvent = function sendBotActionEvent(eventName, intent, sessionId, val, event) {
  var botProjectId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';


  var id = intent && intent.name ? intent.name.split('/agent/intents/')[1] : '';

  var eventToSend = [['intent', intent.displayName], ['id', id], ['bsid', sessionId], ['text', val]];
  if (event) {
    eventToSend.push(['event', event]);
  }

  sendEvent('custom', eventName, eventToSend);

  if (eventName === 'cx.help-bot.button.click') {
    _surveyDataNotifier2.default.notifyUserUtterance(botProjectId, {
      lastIntentId: id,
      utterance: val,
      bsid: sessionId
    });
  }
};

/**
 * Sends chat escalate event
 *
 * @param {Object} response Full response of the event
 * @param {string} sessionId The id of the bot session the user is in
 * @param {string} productId The productId selected
 * @private
 */
var sendChatEscalateEvent = function sendChatEscalateEvent(response, sessionId, productId) {
  var intent = response.queryResult.intent.displayName;
  var id = response.queryResult.intent.name.split('/agent/intents/')[1];
  sendEvent('custom', 'cx.help-bot.user.chat', [['intent', intent], ['id', id], ['bsid', sessionId], ['product', productId]]);
};

/**
 * Sends Chat End Event
 *
 * @param {string} sessionId The id of the bot session the user is in
 * @param {string} productId The productId selected
 * @private
 */
var sendChatEndEvent = function sendChatEndEvent(sessionId, productId) {
  sendEvent('custom', 'cx.help-bot.user.chat-end', [['bsid', sessionId], ['product', productId]]);
};

/**
 * Sends Chat Start Event
 *
 * @param {string} sessionId The id of the bot session the user is in
 * @param {string} productId The productId selected
 * @private
 */
var sendChatStartEvent = function sendChatStartEvent(sessionId, productId) {
  sendEvent('custom', 'cx.help-bot.user.chat.start', [['bsid', sessionId], ['product', productId]]);
};

/**
 * Sends image traffic event
 *
 * @param {Object} imageProps The react props of the image
 * @param {Object} imageState The react state of the image
 * @private
 */
var sendImageEvent = function sendImageEvent(imageProps, imageState) {
  sendEvent('custom', 'cx.help-bot.bot.image', [['intent', imageProps.intent.displayName], ['id', imageProps.intent.name.split('/agent/intents/')[1]], ['bsid', imageProps.sessionId], ['text', imageState.src]]);
};

/**
 * Sends link click traffic event
 *
 * @param {string} eventName Ending of the name of the traffic event
 * @param {string} intent The intent object the link is related to
 * @param {string} sessionId The id of the bot session the user is in
 * @param {string} url The url of the clicked link, without the preceding protocol
 * @private
 */
var sendLinkClickEvent = function sendLinkClickEvent(eventName, intent, sessionId, url) {
  var intentDisplayName = intent.displayName;
  var id = intent && intent.name ? intent.name.split('/agent/intents/')[1] : '';

  sendEvent('custom', 'cx.help-bot.user.link-click.' + eventName, [['intent', intentDisplayName], ['id', id], ['bsid', sessionId], ['text', url]]);
};

/**
 * Sends search results traffic event
 *
 * @param {Object} searchProps The react props of the bot action search
 * @private
 */
var sendSearchResultsEvent = function sendSearchResultsEvent(searchProps) {
  if (searchProps.msg) {
    var results = [];
    searchProps.msg.results.forEach(function (result, index) {
      results[index] = parse(result.link);
    });
    sendBotActionEvent('cx.help-bot.bot.search.results', searchProps.intent, searchProps.sessionId, results.toString());
  }
};

/**
 * Sends request a call create event traffic event
 *
 * @param {Object} msg request a call msg
 * @private
 */
var sendRequestACallCreateEvent = function sendRequestACallCreateEvent(msg) {
  sendEvent('custom', 'cx.help-bot.create-rac', [['agentDisplay', msg.agentDisplay], ['callbackTime', msg.callbackTime], ['callbackEndTime', msg.callbackEndTime], ['callTypeID', msg.callTypeID], ['routeId', msg.routeId], ['shopperId', msg.shopperId], ['status', msg.status], ['timeStamp', msg.timeStamp], ['ucid', msg.ucid], ['visitorId', msg.visitorId], ['waitTime', msg.waitTime]]);
};

exports.default = {
  parse: parse,
  sendBotActionEvent: sendBotActionEvent,
  sendChatEscalateEvent: sendChatEscalateEvent,
  sendChatEndEvent: sendChatEndEvent,
  sendChatStartEvent: sendChatStartEvent,
  sendEvent: sendEvent,
  sendImageEvent: sendImageEvent,
  sendImpression: sendImpression,
  sendLinkClickEvent: sendLinkClickEvent,
  sendRequestACallCreateEvent: sendRequestACallCreateEvent,
  sendSearchResultsEvent: sendSearchResultsEvent,
  sendUtteranceEvent: sendUtteranceEvent
};